import { useEffect, useState } from 'react';
import { ColumnOption } from './CustomizedFundList';

interface SortCompProps {
    className?: string;
    column: ColumnOption;
    selectedSortId: string;
    onChangeSorting: (sorting: string, sortId: string, sortAnalyticLabel: string) => void;
    sorting: string;
    defaultSortingOrder: string;
}

const SortComp = (props: SortCompProps) => {
    const { className, column, selectedSortId, onChangeSorting, defaultSortingOrder } = props;
    const defaultSorting = defaultSortingOrder === 'ascending' ? 'descending' : 'ascending';
    // Local state to manage sorting direction for this arrow
    const [sortingDirection, setSortingDirection] = useState<string>(defaultSorting);

    const changeSorting = () => {
        const newSorting = sortingDirection === 'ascending' ? 'descending' : 'ascending';
        setSortingDirection(newSorting);
        onChangeSorting(newSorting, column?.sortId || '', column?.sortAnalyticLabel || '');
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
        if (event.key === 'Enter') {
            changeSorting();
        }
    };

    // reset for not selected column
    useEffect(() => {
        if (selectedSortId !== column?.sortId) {
            setSortingDirection(defaultSortingOrder);
        }
    }, [column?.sortId, defaultSortingOrder, selectedSortId]);

    return (
        <button
            className={`sort-button ${className || ''}`}
            tabIndex={0}
            onKeyDown={(e) => handleKeyDown(e)}
        >
            {column?.iconType === 'FontAwesome icon' ? (
                <i
                    data-testid="sort-icon"
                    className={`sort-icon fa ${
                        column.sortId === selectedSortId
                            ? sortingDirection === 'ascending'
                                ? column.iconUp
                                : column.iconDown
                            : column.iconSort
                    }`}
                    onClick={changeSorting}
                />
            ) : (
                column?.iconType === 'Image' && (
                    <img
                        className={'sort-image'}
                        data-testid="sort-icon"
                        src={
                            column.sortId === selectedSortId
                                ? sortingDirection === 'ascending'
                                    ? column.imageUp
                                    : column.imageDown
                                : column.imageSort
                        }
                        alt={'sort'}
                        onClick={changeSorting}
                    />
                )
            )}
        </button>
    );
};

export default SortComp;
